import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { CustomerShareIndicadorPipe } from './customer-share-indicador.pipe';
import { CustomerShareIndicadorBadgePipe } from './customer-share-indicador-badge.pipe';
import { CustomerShareIndicadorColorPipe } from './customer-share-indicador-color.pipe';

@NgModule({
    imports:[
        SharedModule
    ],
    declarations: [
        CustomerShareIndicadorPipe,
        CustomerShareIndicadorBadgePipe,
        CustomerShareIndicadorColorPipe
    ],
    exports: [
        CustomerShareIndicadorPipe,
        CustomerShareIndicadorBadgePipe,
        CustomerShareIndicadorColorPipe
    ],
    providers: [
        CustomerShareIndicadorPipe,
        CustomerShareIndicadorBadgePipe,
        CustomerShareIndicadorColorPipe
    ]
})
export class CustomerShareIndicadorPipeModule { }
